import { NavLink } from 'react-router-dom'
import { useSession } from '../../session'

// Pieces shared by the Settings pages: who may open each one, and the
// section tabs across the top.

/** Who may open each Settings page (the same rules as the routes). */
export function useSettingsAccess() {
  const { roles = [], has } = useSession()
  const admin = roles.includes('admin')
  const books = admin || roles.includes('accounting')
  return { admin, company: admin, plan: admin, accountant: admin, payments: books, banks: books, audit: admin, data: admin }
}

export function SettingsTabs() {
  const can = useSettingsAccess()
  const tabs = [
    { to: '/settings/company', label: 'Company', show: can.company },
    { to: '/settings/plan', label: 'Plan & billing', show: can.plan },
    { to: '/settings/accountant', label: 'Accountant', show: can.accountant },
    { to: '/settings/payments', label: 'Payments', show: can.payments },
    { to: '/settings/mono', label: 'Bank connections', show: can.banks },
    { to: '/utilities/audit', label: 'Audit log', show: can.audit },
    { to: '/settings/data', label: 'Data', show: can.data },
  ].filter((t) => t.show)
  return (
    <nav className="section-tabs" aria-label="Settings">
      {tabs.map(({ to, label }) => <NavLink key={to} to={to}>{label}</NavLink>)}
    </nav>
  )
}

/** A page title with a one-line description, and optional buttons on the right. */
export function SettingsHeader({ title, meta, actions }) {
  return (
    <div className="ci-header-row">
      <div className="ci-title-block">
        <div>
          <h1>{title}</h1>
          {meta && <div className="ci-title-meta">{meta}</div>}
        </div>
      </div>
      {actions && <div className="ci-header-actions">{actions}</div>}
    </div>
  )
}
